module.exports = __webpack_public_path__ + "img/vi.5e9460e3.svg";